export const SelectWrapper = ({ label, children, required }) => {
  const styles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    placeholder: (provided) => ({
      ...provided,
      color: '#78909C',
      fontSize: '14px'
    })
  }

  return (
    <div className='relative z-11'>
      <label className='absolute -top-2 left-2 px-1 pl-1 z-10 bg-white text-blue-gray-400 font-light text-[11px] '>
        {required ? <span>{label} <span className='text-red-500'>*</span></span> : label}
      </label>
      {children(styles)}
    </div>
  )
}
